import jwtDecode from 'jwt-decode';
// eslint-disable-next-line
import moment from 'moment';
import { startsWith } from 'lodash';
import { AUTH_REFRESH_TOKEN, AUTH_TOKEN } from 'redux/constants/Auth';
import { refreshToken } from 'redux/actions/Auth';

let buffer = [];

const isExpired = (token, refreshToken) => {
    const expiration = jwtDecode(token).exp;
    const expirationRefresh = jwtDecode(refreshToken).exp;

    // eslint-disable-next-line
    const restTime = expiration * 1000 - Date.now();
    // eslint-disable-next-line
    const restTimeRefresh = expirationRefresh * 1000 - Date.now();

    // eslint-disable-next-line
    const formatted = moment.duration(restTime);
    // eslint-disable-next-line
    const formattedRefresh = moment.duration(restTimeRefresh);

    //console.log(`TOKEN REMAINING TIME: ${formatted.hours()}h, ${formatted.minutes()}min, ${formatted.seconds()}sec`);
    //console.log(`REFRESH TOKEN REMAINING TIME: ${formattedRefresh.days()}days, ${formattedRefresh.hours()}h, ${formattedRefresh.minutes()}min, ${formattedRefresh.seconds()}sec`);

    return ((expiration * 1000 - Date.now()) / 1000) < 0
}

const authMiddleware = store => next => action => {    
    let isTokenExpired = false;

    if (action.type === 'REFRESH_TOKEN') {
        return next(action);
    }

    if (action.type === 'REFRESH_TOKEN_SUCCESS') {   
        next(action);
        if (buffer.length > 0) {
            console.log("##############")
            console.log("BUFFER");
            console.log(buffer);
            console.log("##############")
            buffer.forEach(action => store.dispatch(action));
            buffer = [];
        }
    }

    if (!startsWith(action.type, 'REFRESH_TOKEN') &&
        !startsWith(action.type, 'SIGNOUT') &&
        !startsWith(action.type, 'SIGNUP') &&
        !startsWith(action.type, 'TOGGLE_COLLAPSED_NAV') &&
        !startsWith(action.type, 'CHANGE_LOCALE') &&
        !startsWith(action.type, 'SIDE_NAV_STYLE_CHANGE') &&
        !startsWith(action.type, 'NAV_TYPE_CHANGE') &&
        !startsWith(action.type, 'TOP_NAV_COLOR_CHANGE') &&
        !startsWith(action.type, 'HEADER_NAV_COLOR_CHANGE') &&
        !startsWith(action.type, 'TOGGLE_MOBILE_NAV') &&
        !startsWith(action.type, 'SWITCH_THEME') && 
        !startsWith(action.type, 'DIRECTION_CHANGE')) {
        if (localStorage.getItem(AUTH_TOKEN)) {
            isTokenExpired = isExpired(localStorage.getItem(AUTH_TOKEN), localStorage.getItem(AUTH_REFRESH_TOKEN));
            if (localStorage.getItem(AUTH_TOKEN) && isTokenExpired) {
                if (buffer.length === 0) {
                    console.log("----------------------------------");
                    console.log("----------REFRESH TOKEN-----------");
                    console.log("----------------------------------");
                    store.dispatch(refreshToken());
                }
                buffer.push(action);
            }
        }
    }

    if (!isTokenExpired && action.type !== 'REFRESH_TOKEN_SUCCESS') {
        return next(action);
    }
}

export default authMiddleware